import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../../Components/NavigationLayout";
import Edit from "./Edit";

const Categories = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/faqs/categories" component={List} />
        <Route path="/admin/faqs/categories/new" component={Add} />
        <Route path="/admin/faqs/categories/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Categories;
